import { HelpCircle } from 'lucide-react'
import { Link } from 'react-router-dom'

const FAQ = () => {
  const faqs = [
    {
      question: "How to reach Manauna Dham?",
      answer: "Aonla Stay is located very conveniently near the temple. You can easily reach Manauna Dham via local transport, cabs, or private vehicles right from our property."
    },
    {
      question: "What room types do you offer?",
      answer: "We offer Standard Rooms at ₹999/night and Deluxe Rooms at ₹1,499/night. Both come with complimentary amenities for a comfortable stay."
    },
    {
      question: "Is parking available at the stay?",
      answer: "Yes, we provide secure, on-site parking completely free of charge for all our registered guests."
    },
    {
      question: "What are the check-in and check-out times?",
      answer: "Check-in is from 12:00 PM (Noon), and check-out is until 11:00 AM. Early check-in or late check-out may be available upon request, subject to availability."
    },
    {
      question: "Can I modify my booking?",
      answer: "Yes, you can modify your stay dates or room type up to 24 hours before check-in, subject to availability without any extra penalty."
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-secondary-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <HelpCircle className="h-12 w-12 mx-auto mb-4 text-primary-400" />
          <h1 className="text-3xl md:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
            Find answers to our most common booking questions below
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8 hover:shadow-md transition-shadow">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <Link to="/rooms" className="inline-block px-8 py-3 bg-primary-500 text-white font-semibold rounded-lg shadow hover:bg-primary-600 transition-colors">
              Book Your Stay
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FAQ
